module.exports = __webpack_public_path__ + "static/media/user.261bab48.svg";